import axios from 'axios';
import { Toast, Notify } from 'vant'
import { request, response } from '../encryption';


let Http = axios.create({
    baseURL: '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8;'
    },
});

let loading
let reqNum = 0
let startLoading = () => {
    /** 判断请求是否全部加载完成 */
    reqNum++
    loading = Toast.loading({
        message: '',
        forbidClick: true,
        duration: 0
    })
}
let endLoading = () => {
    /** 判断请求是否全部加载完成 */
    reqNum--
    if (reqNum <= 0) {
        loading.clear()
    }
}

// 添加一个请求拦截器
Http.interceptors.request.use((config) => {
    startLoading()
    console.warn(`[发起请求]---${new Date()}---`);
    console.warn(`[请求地址][${config.method}]${config.url}`);
    console.warn(`[请求配置]`);
    config.headers.authentication = localStorage.authentication;
    if(localStorage.shopNo) {
        config.headers.shopNo = localStorage.shopNo;
    }
    
    config.headers.userLocation = localStorage.addressCity?encodeURIComponent(localStorage.addressCity):undefined;
    // if(localStorage.addressCity) {
        
    // }
    return request(config);
}, function (error) {
    
    return Promise.reject(error);
});

// 添加一个响应拦截器
Http.interceptors.response.use((res) => {
    endLoading()
    Toast.clear();
    console.warn(`[请求结束]---${new Date()}---`);
    // console.warn(`[请求结果]---${config}---`);
    return response(res).data;
}, function (error) {
    console.warn(`[请求错误]---${error}---`)
    // console.log(window.location.href)
    if(error.response.status=='406') {
        console.log('qingaw')
        localStorage.removeItem("authentication");
        localStorage.removeItem("openid");
        localStorage.removeItem("userInfo");
        localStorage.removeItem('isLogin')
        localStorage.removeItem('isScope')


        let a = window.location.protocol;
        let b = window.location.host;
        let c = `${a}//${b}/`
        localStorage.domainUrl = c
        let t ;
        clearTimeout(t)
        t = setTimeout(function() {
            location.reload()
            // window.eventHub.$emit('refreshList', '')// 更新右侧列表状态
        }, 2000)
    }else if(error.response.status=='407') {
        window.location.href = `/#/jump?shopNo=${localStorage.shopNo?localStorage.shopNo:''}&redirectUri=${encodeURIComponent(localStorage.return_url)}`
    }else {
        Toast(error)
    }

    return Promise.reject(error);
});


export default Http;